import { render } from "./Dashbord.vue?vue&type=template&id=2750eef6"
import script from "./Dashbord.vue?vue&type=script&lang=js"
export * from "./Dashbord.vue?vue&type=script&lang=js"

import "./Dashbord.vue?vue&type=style&index=0&id=2750eef6&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_b7ac09e112f74cf29c780ec3b0fe9d8e/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__